import { render, staticRenderFns } from "./UnboxHeaderBox.vue?vue&type=template&id=02145ac4&scoped=true"
import script from "./UnboxHeaderBox.vue?vue&type=script&lang=js"
export * from "./UnboxHeaderBox.vue?vue&type=script&lang=js"
import style0 from "./UnboxHeaderBox.vue?vue&type=style&index=0&id=02145ac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02145ac4",
  null
  
)

export default component.exports